import Breadcrumbs from '../components/Breadcrumbs';
import Link from '../components/Link';
import PrintButton from '../components/PrintButton';
import WorksheetSheet from '../components/worksheets/WorksheetSheet';
import NotFoundPage from './NotFoundPage';
import { CONTENT_CLASSES, WORKSHEET_CLASSES } from '../constants/classNames';
import { ROUTES } from '../constants/config';
import { findWorksheetBySlug } from '../data/worksheets';
import { buildWorksheetAnswersPath, buildWorksheetPath } from '../utils/routeUtils';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/ContentPage.css';
import '../styles/Worksheet.css';

/**
 * The answer key for a worksheet, on its own page so children don't see it on the sheet.
 */
export default function WorksheetAnswersPage({ slug }) {
  const worksheet = findWorksheetBySlug(slug);
  if (!worksheet?.hasAnswers) return <NotFoundPage />;
  const worksheetPath = buildWorksheetPath(worksheet);

  return (
    <article className={joinClassNames(CONTENT_CLASSES.root, WORKSHEET_CLASSES.page)}>
      <Breadcrumbs
        trail={[
          { label: 'Lab', path: ROUTES.LAB },
          { label: 'Parents & teachers', path: ROUTES.PARENTS },
          { label: worksheet.title, path: worksheetPath },
          { label: 'Answer key', path: buildWorksheetAnswersPath(worksheet) },
        ]}
      />
      <header className={CONTENT_CLASSES.hero}>
        <h1 className={CONTENT_CLASSES.heading}>Answer key: {worksheet.title}</h1>
      </header>
      <div className={joinClassNames(WORKSHEET_CLASSES.actions, WORKSHEET_CLASSES.noPrint)}>
        <PrintButton label="Print the answer key" />
        <Link to={worksheetPath}>Back to the worksheet</Link>
      </div>
      <WorksheetSheet worksheet={worksheet} showAnswers />
    </article>
  );
}
